import { Formik } from "formik";
import { useEffect, useState } from "react";
import Spin from "../../../../components/Spin";
import { Label } from "../../../../components/ui/label";
import CustomLabelText from "../../../../components/CustomLabelText";
import { Input } from "../../../../components/ui/input";
import { API, fileUpload, get } from "../../../../config";
import { Button } from "../../../../components/ui/button";
import { AddAdminVersionSchema } from "../../../../lib/Validation";
import { Textarea } from "../../../../components/ui/textarea";

const AddEditVersion = ({
  id,
  toggleShowAddEditVersion,
  edit,
  fetchVersionData,
}) => {
  const [versionData, setVersionData] = useState([]);
  const [loading, setLoading] = useState(false);

  async function fetchData() {
    try {
      setLoading(true);
      const reponse = await get(`${API.ADMIN_VERSION_DETAILS}/` + id);
      setVersionData(reponse?.data?.data);
      setLoading(false);
    } catch (e) {
      setVersionData(null);
    }
  }

  useEffect(() => {
    if (edit) {
      fetchData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  const handleFormSubmit = async (value) => {
    const formData = new FormData();

    formData.append(
      "version_number",
      value?.version_number ? value?.version_number : ""
    );
    formData.append("name", value?.name ? value?.name : "");
    formData.append(
      "description",
      value?.description ? value?.description : ""
    );

    if (edit) {
      formData.append("_method", "put");
    }
    try {
      setLoading(true);
      const { data } = await fileUpload(
        `${API.ADMIN_VERSION_ADD}${edit ? `/${id}` : ""}`,
        formData
      );
      setLoading(false);
      if (data) {
        toggleShowAddEditVersion();
        fetchVersionData();
      }
      return data?.data;
    } catch (error) {
      setLoading(false);
    }
  };

  return (
    <Formik
      initialValues={{
        version_number: versionData?.version_number,
        name: versionData?.name,
        description: versionData?.description,
      }}
      enableReinitialize={true}
      onSubmit={handleFormSubmit}
      validateOnBlur={true}
      validateOnChange={true}
      validationSchema={AddAdminVersionSchema}
    >
      {({
        values,
        errors,
        handleChange,
        handleBlur,
        handleSubmit,
        setFieldValue,
        isValid,
      }) => (
        <>
          {loading && <Spin />}
          <form
            onSubmit={handleSubmit}
            noValidate
            className="entry-version md:m-0 m-5"
          >
            <div className="form-box overflow-y-auto overflow-x-hidden max-h-[80vh] p-4 border rounded-lg">
              <div className="grid gap-4">
                <div className="grid md:grid-cols-1 gap-4">
                  <div className="grid gap-2">
                    <Label htmlFor="version_number">
                      <CustomLabelText
                        required={true}
                        labelText="Version Number"
                        errorField={errors?.version_number}
                        bottomAlign={true}
                      />
                    </Label>
                    <Input
                      id="version_number"
                      type="number"
                      name="version_number"
                      value={
                        values?.version_number ? values?.version_number : ""
                      }
                      onChange={handleChange}
                      onBlur={handleBlur}
                      autoComplete="off"
                      onKeyPress={(e) => {
                        e.which === 13 && e.preventDefault();
                      }}
                      className={
                        errors?.version_number &&
                        `focus-visible:ring-red-500 border-red-500`
                      }
                    />
                  </div>
                  <div className="grid gap-2">
                    <Label htmlFor="name">
                      <CustomLabelText
                        required={true}
                        labelText="Name"
                        errorField={errors?.name}
                      />
                    </Label>
                    <Input
                      id="name"
                      type="text"
                      name="name"
                      value={values?.name ? values?.name : ""}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      autoComplete="off"
                      onKeyPress={(e) => {
                        e.which === 13 && e.preventDefault();
                      }}
                      className={
                        errors?.name &&
                        `focus-visible:ring-red-500 border-red-500`
                      }
                    />
                  </div>
                  {/* DESCRIPTION */}
                  <div className="grid gap-2">
                    <Label htmlFor="description">
                      <CustomLabelText
                        required={true}
                        labelText="Description"
                        errorField={errors?.description}
                      />
                    </Label>
                    <Textarea
                      id="description"
                      name="description"
                      value={values.description}
                      rows={3}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      className={
                        errors?.description
                          ? "border-red-500 focus-visible:ring-red-500"
                          : ""
                      }
                    />
                  </div>
                </div>
              </div>
            </div>

            <div className="modal-footer pt-4 border-t mt-4 flex items-center justify-end">
              <Button type="submit" disabled={!isValid}>
                Save
              </Button>
              <Button
                className="reset ml-3"
                data-dismiss="modal"
                aria-label="Close"
                onClick={(e) => {
                  e.preventDefault();
                  toggleShowAddEditVersion();
                }}
                variant="secondary"
              >
                Cancel
              </Button>
            </div>
          </form>
        </>
      )}
    </Formik>
  );
};

export default AddEditVersion;
